import React from "react";
import { ArrowDown, ArrowUp, Minus } from "lucide-react";
import { GrcCard } from "@/components/grc/shared";

const SEGMENTS = [
  { key: "critical", label: "Critical", color: "#D32F2F" },
  { key: "major", label: "Major", color: "#F57C00" },
  { key: "minor", label: "Minor", color: "#FBC02D" },
  { key: "pass", label: "Pass", color: "#388E3C" },
];

const TrendArrow = ({ trend, isPass }) => {
  if (!trend) return <Minus size={13} className="text-slate-300" />;
  const improving = isPass ? trend > 0 : trend < 0;
  const Icon = trend < 0 ? ArrowDown : ArrowUp;
  return (
    <span className={`inline-flex items-center gap-0.5 text-[11px] font-semibold ${improving ? "text-green-600" : "text-red-600"}`}>
      <Icon size={12} />
      {Math.abs(trend)}
    </span>
  );
};

export const GapDistribution = ({ data }) => {
  const total = SEGMENTS.reduce((s, seg) => s + (data?.[seg.key]?.count || 0), 0);
  return (
    <GrcCard
      title="Gap Distribution"
      info="Live count of controls by gap tag. Trend arrows compare against the most recent compliance snapshot."
      testId="gap-distribution-widget"
    >
      <div className="flex h-4 w-full rounded-full overflow-hidden bg-slate-100 mb-4" data-testid="gap-distribution-bar">
        {SEGMENTS.map((seg) => {
          const count = data?.[seg.key]?.count || 0;
          if (!count || !total) return null;
          return (
            <div
              key={seg.key}
              style={{ width: `${(count / total) * 100}%`, backgroundColor: seg.color }}
              title={`${seg.label}: ${count}`}
            />
          );
        })}
      </div>
      <div className="space-y-2">
        {SEGMENTS.map((seg) => (
          <div key={seg.key} className="flex items-center justify-between text-xs" data-testid={`gap-row-${seg.key}`}>
            <span className="flex items-center gap-2 text-slate-600">
              <span className="w-2.5 h-2.5 rounded-sm" style={{ backgroundColor: seg.color }} />
              {seg.label}
            </span>
            <span className="flex items-center gap-2">
              <span className="font-semibold text-slate-800 tabular-nums">{data?.[seg.key]?.count ?? 0}</span>
              <TrendArrow trend={data?.[seg.key]?.trend || 0} isPass={seg.key === "pass"} />
            </span>
          </div>
        ))}
      </div>
    </GrcCard>
  );
};
